module.exports = __webpack_public_path__ + "img/2.7c3de606.png";